/**
 * 契約中のプラン一覧画面のグロッサリIDの型定義
 *
 * IDの先頭5桁（GL00x）は同一ファイル内では同じものを使用し、グロッサリファイル間では一意とする。
 * それ以降の5桁はファイル内でIDが被らないように採番する。
 */
export const ContractGL = {
  /** 購入日 */
  OperationDatetime: 'GL00600001',
  /** 次回請求日 */
  ExpirationDatetime: 'GL00600002',
  /** 料金 */
  ContractPlanPrice: 'GL00600003',
  /** 購入番号 */
  VendorPurchaseId: 'GL00600004',
  /** 詳細を見る */
  Detail: 'GL00600005',
  /** 解約 */
  Cancel: 'GL00600006',
  /** 契約中 */
  Contract: 'GL00600007',
  /** 購入履歴 */
  History: 'GL00600008',
  /** 情報を取得できませんでした */
  OtherError: 'GL00600009',
  /** 金額・サブスクリプションラベル */
  SubscriptionPrice: 'GL00600010',
  /** 該当プランがありません */
  NotFoundAnyContract: 'GL00600011',
  /** 有効期限 */
  ExpirationDateForDemo: 'GL00600012',
  /** 合計消費数 */
  TotalUsage: 'GL00600013',
  /** 解約されています */
  AlreadyCanceled: 'GL00600014',
  /** デバイス数 */
  NumberOfDevicesUsed: 'GL00600015',
  /** デバイス管理 */
  DeviceManagement: 'GL00600016',
  /** 他ユーザー利用 */
  UseByOtherUsers: 'GL00600017',
  /** 他ユーザー管理 */
  OtherUserManagement: 'GL00600018',
  /** 購入者に返却 */
  ReturnToBuyer: 'GL00600019',
  /** 注文数 */
  NumberOfOrders: 'GL00600020',
  /** 有効期限が過ぎています */
  GracePeriodExpired: 'GL00600021',
  /** 自動更新が停止中です */
  ManualUpdate: 'GL00600022',
  /** 機能の有効化(AVAILABLE_0025) */
  DeviceActivate: 'GL00600023',
  /** カメラ登録数(AVAILABLE_0026) */
  NumberOfPlanUsage: 'GL00600024'
} as const;
export type ContractGLKeys = typeof ContractGL[keyof typeof ContractGL];
